import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

/**
 * プライベートクルーザーの拡大表示画像のパス、幅、高さ、説明を記入
 */
const privateCruising = [
  { url: "privateCruising/pic_2.jpg", width: 675, height: 450, alt: "" },
  { url: "privateCruising/pic_1.jpg", width: 800, height: 533, alt: "" },
  { url: "privateCruising/pic_21.jpg", width: 800, height: 510, alt: "" },
  {
    url: "privateCruising/pic_4.jpg",
    width: 551,
    height: 398,
    alt: "リーバ68",
  },
  {
    url: "privateCruising/pic_5.jpg",
    width: 700,
    height: 467,
    alt: "リーバ68",
  },
  {
    url: "privateCruising/pic_6.jpg",
    width: 648,
    height: 432,
    alt: "リーバ68",
  },
  {
    url: "privateCruising/pic_7.jpg",
    width: 800,
    height: 627,
    alt: "リーバ68",
  },
  {
    url: "privateCruising/pic_8.jpg",
    width: 555,
    height: 370,
    alt: "ロッドマン41",
  },
  {
    url: "privateCruising/pic_9.jpg",
    width: 604,
    height: 426,
    alt: "ロッドマン41",
  },
  {
    url: "privateCruising/pic_18.jpg",
    width: 800,
    height: 532,
    alt: "シーレイ38",
  },
];

/**
 * 無料お食事の拡大表示画像のパス、幅、高さ、説明を記入
 */
const freeFood = [
  {
    url: "freefood/pic_1.jpg",
    width: 900,
    height: 600,
    alt: "アンティカ・オステリア・デル・ポンテ",
  },
  {
    url: "freefood/pic_2.jpg",
    width: 900,
    height: 600,
    alt: "ＧＩＮＺＡ ｋａｎｓｅｉ",
  },
  { url: "freefood/pic_7.jpg", width: 800, height: 534, alt: "中国料理　燦宮" },
];

// initial state
const state = {
  showImg: null, // room information
  imageArray: null,
  image: "",
};

// mutations
const mutations = {
  setShowImage(state, num) {
    state.showImg = num[0];
    state.image = num[1];

    if (state.showImg == "privateCruising") {
      state.imageArray = privateCruising;
    } else if (state.showImg == "freefood") {
      state.imageArray = freeFood;
    }
  },
};

// actions
const actions = {
  show(context, num) {
    context.commit("setShowImage", num);
  },
  hide(context, num) {
    context.commit("setShowImage", num);
  },
};

// getters
const getters = {
  getShowImage: function (state) {
    return state.showImage;
  },
};

export default {
  // 名前空間を使うように
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
